// extracted by mini-css-extract-plugin
module.exports = {"imageSlider":"image-slider-module--imageSlider--TW9Yg"};